import { useState, useEffect } from 'react';

const CustomSelect = ({placeholder, selectOption, setselectOption, options}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSelect, setisSelect] = useState(false);

  useEffect(() => {
    // 초기값이 있는 경우 선택 상태로 설정
    if (selectOption && options.includes(selectOption)) {
      setisSelect(true);
    }
  }, [selectOption, options]);

  const handleSelect = (option) => {
    setselectOption(option);
    setIsOpen(false);
    setisSelect(true);
  };

  return (
    <div className="relative w-full">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="border border-[#D0D5DD] w-full h-[54px] rounded-lg px-4 flex items-center justify-between"
      >
        <span className={!isSelect ? 'text-[#AEB0B6]' : 'text-black'}>
          { !isSelect ? placeholder : selectOption }
        </span>
        <img
          src="/assets/img/select.svg"
          className={`transition-transform duration-200 w-4 ${isOpen ? 'rotate-180' : ''}`}
          color="#AEB0B6"
        />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 w-full mt-1 border border-[#D0D5DD] bg-white rounded-lg shadow-lg z-10">
          {options.map((option) => (
            <div
              key={option}
              onClick={() => handleSelect(option)}
              className="flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-gray-50"
            >
              {option}
              {selectOption === option && (
                <img src="/assets/img/input-check.svg" alt="selected" className="w-4" />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;